import interestsService from '../../services/api/user-interests'
import { useMutation } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'
import { useState } from 'react'

const useUserInterestsMutations = ({
    userId,
    onSuccess = () => {},
    onError = () => {},
    interests: initialInterests = []
}) => {
    const [ userInterests, setUserInterests ] = useState(initialInterests)
    const cacheKeys = useCacheKeys()

    const { clearCache } = useCache({
        key: cacheKeys.USER_INTERESTS,
        onReload: onSuccess,
    })

    const [ updateUserInterests, { isLoading }] = useMutation(() => interestsService.update({ userId, interestIds: userInterests }), {
        onSuccess: clearCache,
        onError,
    })

    return {
        isUpdating: isLoading,
        updateUserInterests,
        userInterests,
        setUserInterests,
    }
}

export default useUserInterestsMutations